var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 10.0007C11.8416 10.0007 13.3333 8.50898 13.3333 6.66732C13.3333 4.82565 11.8416 3.33398 9.99992 3.33398C8.15825 3.33398 6.66659 4.82565 6.66659 6.66732C6.66659 8.50898 8.15825 10.0007 9.99992 10.0007ZM9.99992 11.6673C7.77492 11.6673 3.33325 12.784 3.33325 15.0007V16.6673H16.6666V15.0007C16.6666 12.784 12.2249 11.6673 9.99992 11.6673Z",
    fill: "#8DBDF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d07f88a3c5b4a43882fc8d08a27a4bb8.svg";
export { ForwardRef as ReactComponent };